export const dataLineageDiagramConfig = {
  layerSpacing: 100,
  columnSpacing: 5,
  defaultScale: 0.7,
  zOrder: {
    default: 0,
    selected: 5,
    highlighted: 10,
  },
  group: {
    textLength: 18,
    iconSize: 18,
  },
  node: {
    iconSize: 18,
    notFound: {
      width: 260,
    },
  },
  colors: {
    black: '#20202A',
    grey: '#9e9e9e',

    group: {
      shadow: '#0000001A',
    },
  },
  font: {
    family: 'Helvetica Neue',
    style: 'Normal',
    size: {
      big: '16px',
      regular: '14px',
      small: '12px',
    },
  },
  tooltip: {
    fontColor: '#666666',
    background: '#ffffff',
  },
};

export const dataLineageButtons = {
  overview: {
    svg: 'M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13zM12 8c-1.105 0-2 0.895-2 2s0.895 2 2 2h5.172l-8.586 8.586c-0.781 0.781-0.781 2.047 0 2.829 0.39 0.39 0.902 0.586 1.414 0.586s1.024-0.195 1.414-0.586l8.586-8.586v5.172c0 1.105 0.895 2 2 2s2-0.895 2-2v-12h-12z',
    fill: {
      lightMode: '#D2D2D2',
      darkMode: '#E9E7EB',
    },
    border: 'transparent',
    hover: {
      fill: 'transparent',
      border: '#D2D2D2',
    },
  },
  clipboard: {
    svg: 'M13.7432 1.93129L12.0684 0.256484C11.9057 0.0921758 11.6815 0 11.4491 0H6.97567C6.00907 0 5.22567 0.783672 5.22567 1.75L5.2262 8.75C5.25028 9.71797 6.03504 10.5 7.00028 10.5H12.2503C13.2128 10.5 14.0003 9.7125 14.0003 8.75V2.5498C14.0003 2.31793 13.9073 2.09535 13.7432 1.93129ZM12.6878 8.75C12.6878 8.99161 12.4919 9.1875 12.2503 9.1875H6.97567C6.734 9.1875 6.53817 8.99161 6.53817 8.75V1.75355C6.53817 1.51195 6.73406 1.31605 6.97567 1.31605H10.4757L10.5003 2.625C10.5003 3.10816 10.8921 3.5 11.3753 3.5H12.6632V8.75H12.6878ZM7.43778 12.25C7.43778 12.4916 7.24189 12.6875 7.00028 12.6875H1.72566C1.484 12.6875 1.28816 12.4916 1.28816 12.25L1.31223 5.25273C1.31223 5.01113 1.50812 4.81523 1.74973 4.81523H4.37528V3.5H1.75C0.783399 3.5 0 4.2834 0 5.25L0.000267969 12.25C0.000328125 13.2152 0.783946 14 1.75027 14H7.00028C7.96278 14 8.75028 13.2125 8.75028 12.25V11.375H7.46239L7.43778 12.25Z',
    fill: '#D2D2D2',
    border: 'transparent',
    hover: {
      fill: 'transparent',
      border: '#D2D2D2',
    },
  },
  star: {
    svg: 'M7.49768 0.333496C7.73726 0.333496 7.95601 0.470215 8.06018 0.685579L9.84663 4.36475L13.8388 4.95589C14.0732 4.98975 14.2659 5.15381 14.3414 5.37777C14.4143 5.60433 14.3544 5.85173 14.1878 6.01579L11.2919 8.88558L11.9768 12.9351C12.0159 13.1694 11.9195 13.409 11.7242 13.547C11.5315 13.6851 11.2529 13.7033 11.0654 13.5913L7.49768 11.6851L3.90914 13.5913C3.72164 13.7033 3.46643 13.6851 3.27112 13.547C3.07841 13.409 2.98205 13.1694 2.99768 12.9351L3.70341 8.88558L0.810441 6.01579C0.642212 5.85173 0.582576 5.60433 0.656534 5.37777C0.730232 5.15381 0.924764 4.98975 1.15888 4.95589L5.14872 4.36475L6.93518 0.685579C7.04195 0.470189 7.25809 0.333496 7.49768 0.333496ZM7.49768 2.38949L6.13049 5.2085C6.03934 5.39339 5.86226 5.5236 5.65914 5.55485L2.57789 6.00798L4.81539 8.22412C4.95862 8.36735 5.02372 8.57308 4.98987 8.7736L4.46382 11.8882L7.20341 10.4246C7.3883 10.3257 7.60966 10.3257 7.79195 10.4246L10.5315 11.8882L10.0055 8.7736C9.97163 8.57308 10.0393 8.36735 10.1826 8.22412L12.4195 6.00798L9.33882 5.55485C9.13309 5.5236 8.95601 5.39339 8.86747 5.2085L7.49768 2.38949Z',
    fill: '#D2D2D2',
    border: 'transparent',
    hover: {
      fill: 'transparent',
      border: '#D2D2D2',
    },
  },
  private: {
    svg: 'M16.0714 7.50001H14.7857V5.6797C14.7857 2.57033 12.2143 0.00783056 9.01607 1.80638e-05C5.81786 -0.00779443 3.21429 2.51955 3.21429 5.62501V7.50001H1.92857C0.863839 7.50001 0 8.33985 0 9.37501V18.125C0 19.1602 0.863839 20 1.92857 20H16.0714C17.1362 20 18 19.1602 18 18.125V9.37501C18 8.33985 17.1362 7.50001 16.0714 7.50001ZM5.14286 5.62501C5.14286 3.55861 6.87455 1.87502 9 1.87502C11.1254 1.87502 12.8571 3.55861 12.8571 5.62501V7.50001H5.14286V5.62501ZM16.0714 18.125H1.92857V9.37501H16.0714V18.125Z',
    fill: '#D2D2D2',
    strokeOver: '#D2D2D2',
    border: 'transparent',
    hover: {
      fill: 'transparent',
      border: '#D2D2D2',
    },
    width: 16,
    height: 18,
  },
  public: {
    svg: 'M18.75 9C20.8203 9 22.5 7.27232 22.5 5.14286C22.5 3.01339 20.8203 1.28571 18.75 1.28571C16.6797 1.28571 15 3.01339 15 5.14286C15 7.27232 16.6797 9 18.75 9ZM18.75 3.21429C19.7852 3.21429 20.625 4.07812 20.625 5.14286C20.625 6.20759 19.7852 7.07143 18.75 7.07143C17.7148 7.07143 16.875 6.20759 16.875 5.14286C16.875 4.07812 17.7148 3.21429 18.75 3.21429ZM10.6289 9.80357C10.1641 9.80357 9.69531 9.87187 9.24219 10.0165C8.6875 10.1893 8.10547 10.2857 7.49609 10.2857C6.88672 10.2857 6.30469 10.1893 5.75 10.0165C5.29687 9.87589 4.82812 9.80357 4.36328 9.80357C2.94531 9.80357 1.56641 10.4545 0.757812 11.6879C0.28125 12.4272 0 13.3152 0 14.2714V16.0714C0 17.1362 0.839844 18 1.875 18H13.125C14.1602 18 15 17.1362 15 16.0714V14.2714C15 13.3152 14.7187 12.4272 14.2344 11.6879C13.4258 10.4545 12.0469 9.80357 10.6289 9.80357V9.80357ZM13.125 16.0714H1.875V14.2714C1.875 13.1103 2.59375 12.1179 3.59766 11.7362C4 11.5835 4.44141 11.5875 4.84375 11.7362C5.70703 12.0536 6.60156 12.2143 7.5 12.2143C8.39844 12.2143 9.28906 12.0536 10.1602 11.7362C10.5625 11.5875 11.0039 11.5835 11.4062 11.7362C12.4102 12.1138 13.1289 13.1103 13.1289 14.2714V16.0714H13.125ZM7.5 9C9.91797 9 11.875 6.98705 11.875 4.5C11.875 2.01295 9.91797 0 7.5 0C5.08203 0 3.125 2.01295 3.125 4.5C3.125 6.98705 5.08203 9 7.5 9ZM7.5 1.92857C8.87891 1.92857 10 3.0817 10 4.5C10 5.9183 8.87891 7.07143 7.5 7.07143C6.12109 7.07143 5 5.9183 5 4.5C5 3.0817 6.12109 1.92857 7.5 1.92857ZM24.3633 11.4549C23.6875 10.4263 22.5391 9.88393 21.3594 9.88393C20.2734 9.88393 20 10.2857 18.75 10.2857C17.5 10.2857 17.2266 9.88393 16.1406 9.88393C15.6211 9.88393 15.1172 10.0045 14.6484 10.2094C14.875 10.4464 15.0898 10.6915 15.2734 10.9687C15.457 11.25 15.6094 11.5473 15.7422 11.8527C15.8711 11.8246 16.0039 11.8085 16.1406 11.8085C16.8125 11.8085 17.2969 12.2103 18.75 12.2103C20.2109 12.2103 20.6836 11.8085 21.3594 11.8085C21.9727 11.8085 22.5117 12.0777 22.8086 12.5277C23.0156 12.8451 23.125 13.2147 23.125 13.6004V14.7857H16.25V16.0714C16.25 16.2924 16.2266 16.5054 16.1875 16.7143H23.4375C24.3008 16.7143 25 15.9951 25 15.1071V13.6085C25 12.8089 24.7656 12.0696 24.3633 11.4549V11.4549Z',
    fill: '#35359E',
    border: 'transparent',
    strokeOver: '#D2D2D2',
    hover: {
      fill: 'transparent',
      border: 'orange',
    },
    width: 20,
    height: 16,
  },
  column: {
    svg: 'M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z',
  },
};

export const DataLineageThemeColors = {
  Light: {
    GroupFill: '#FFFFFF',
    GroupFillDisabled: 'rgba(255, 255, 255, 0.6)',
    GroupStroke: '#FFFFFF',
    NodeFill: '#F4F4FC',
    NodeFillDisabled: 'rgba(244, 244, 252, 0.6)',
    NodeStroke: '#F4F4FC',
    Text: '#20202A',
    NodeDivider: '#e4e6ea',
    Arrow: {
      Default: '#DDDDDD',
      Highlighted: '#553798',
      Selected: '#553798',
    },
    Stroke: {
      Highlighted: '#553798',
      Selected: '#553798',
      PathSelection: '#553798',
      FilterHighlight: 'E87F44',
      Peeked: '#6bedd4',
      Active: '#04cd72',
    },
  },
  Dark: {
    GroupFill: '#26282E',
    GroupFillDisabled: 'rgba(38, 40, 46, 0.3)',
    GroupStroke: '#26282E',
    NodeFill: '#373943',
    NodeFillDisabled: 'rgba(55, 57, 67, 0.3)',
    NodeStroke: '#373943',
    Stroke: {
      Highlighted: '#836DFF',
      Selected: '#836DFF',
      PathSelection: '#836DFF',
      FilterHighlight: 'AD5D2A',
      Peeked: '#43C0CA',
      Active: '#31AF77',
    },
    Text: '#E9E7EB',
    NodeDivider: '#484b55',
    Arrow: {
      Default: '#5B5E69',
      Highlighted: '#836DFF',
      Selected: '#836DFF',
    },
  },
  Transparent: 'transparent',
};
